<template>
  <section ref="header" :class="['header', isFixed ? 'fix' : '']">
    <nav>
      <div class="wrap-mulu">
        <i class="mulu-icon iconfont icon-menu2" @click="onOpenMulu"></i>
        <img class="logo fl" @click="toHomePage" :src="logo" alt="logo" >
      </div>
      <transition name="slide-down">
        <ul v-show="isOpenMenus" class="nav-bar fr">
          <li class="fl" @click="handleIndex(menu)" v-for="(menu, i) of menus" :key="i">
            <router-link
              :class="{'color-black': isFixed, 'active': menu.isActive}"
              v-if="menu.url"
              :to="menu.url">
              {{menu.text.toUpperCase()}}
            </router-link>
            <a :class="{'color-black': isFixed}" v-else :href="menu.http">{{menu.text.toUpperCase()}}</a>
          </li>
        </ul>
      </transition>
    </nav>
  </section>
</template>
<script>
export default {
  data () {
    return {
      menus: [
        {
          text: 'Home',
          url: '/',
          isActive: true
        },
        {
          text: 'Advertiser',
          url: '/advertiser',
          isActive: false
        },
        {
          text: 'Affiliate',
          url: '/affiliate',
          isActive: false
        },
        {
          text: 'Company',
          url: '/company',
          isActive: false
        },
        {
          text: 'Categories',
          url: '/campaign',
          isActive: false
        },
        {
          text: 'Blog',
          url: '/blog',
          isActive: false
        },
        {
          text: 'Login',
          http: 'http://taptap.offerslook.com',
          isActive: false
        }
      ],
      logo: require('@/assets/images/logo1.png'),
      activeI: 0,
      isFixed: false,	// 头部的样式切换
      colMulu: false,
      isOpenMenus: true,
      isSmallScreen: false
    }
  },
  props: {
  	nowIndex: {
  		type: Number,
  		default: 0
  	},
  	scrollSize: {
  		type: Number,
  		default: 657
  	}
  },
  created () {
    this.judgeWindowWidth()
  },
  mounted () {
    this.handleIndex()
    if (this.isOpenMenus) {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.judgeWindowWidth)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.judgeWindowWidth)
  },
  watch: {
  	activeI (_new, _pre) {

  	}
  },
  computed: {
  },
  methods: {
  	handleIndex () {
  		this.menus.forEach(val => {
  			val.isActive = false
  		})
  		this.$set(this.menus[this.nowIndex], 'isActive', true)
  	},
  	/**
  	 * 点击按钮展开目录
  	 */
  	onOpenMulu () {
      this.isOpenMenus = !this.isOpenMenus
  		// document.querySelector('.nav-bar').style.display = document.querySelector('.nav-bar').style.display === 'block' ? 'none' : 'block'
      // document.querySelector('.mulu-icon').style.top = document.querySelector('.mulu-icon').style.top === '50%' || document.querySelector('.mulu-icon').style.top === '' ? '11.4%' : '50%'
    },
    /**
     * 点击顶部图标跳转到首页
     */
    toHomePage () {
      this.$router.push('/')
    },
    handleScroll (e) {
      e = e || window.event
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let scrollRate = scrollTop / this.scrollSize
      scrollRate = scrollRate > 0.5
        ? scrollRate > 1
          ? 1
          : scrollRate
        : 0.5
      const header = document.querySelector('.header')
      console.log(scrollTop)
      if (scrollTop >= this.scrollSize / 10) {
        header.style.opacity = scrollRate
      	header.style.boxShadow = '0 0.0625rem 0.1875rem rgba(0,0,0,.11)'
      	this.logo = require('@/assets/images/logo.png')
        this.isFixed = true
      } else {
      	document.querySelector('.header').style.opacity = 1
      	document.querySelector('.header').style.boxShadow = 'none'
      	this.logo = require('@/assets/images/logo1.png')
        this.isFixed = false
      }
    },
    judgeWindowWidth () {
      this.isSmallScreen = window.screen.width < 1000
      if (this.isSmallScreen) {
        this.isOpenMenus = false
        this.logo = require('@/assets/images/logo.png')
      } else {
        this.isOpenMenus = true
        this.logo = require('@/assets/images/logo1.png')
      }
    }
  }
}
</script>
<style lang="scss">
.fix {
  background: white;
}
.header {
  max-width: 1920px;
	.mulu-icon {
		display: none;
	}
	.color-black {
		color: black;
	}
  width: 100%;
  position: fixed;
	top: 0;
  z-index: 100;
  nav {
    padding: 0 2.8125rem;
    // height: 100px;
    overflow: hidden;
    vertical-align: middle;
    .logo {
    	width: 3.75rem;
	    height: 3.75rem;
	    padding: 0.9375rem 0;
    }
    ul {
      list-style: none;
      height: 100%;
      padding: 0;
      margin: 0;
      overflow: hidden;
      li {
        height: 100%;
        a {
          display: inline-block;
          height: inherit;
          padding: 0 1.0625rem;
          text-decoration: none;
          line-height: 7.375rem;
          color: #fff;
          font-weight: 600;
        }
      }
      .active {
        color: #ED3237;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
	.nav-bar {
		// display: none;
		&.fr {
			float: none;
		}
		li {
			height: 2.8125rem !important;
	    text-align: left;
	    border-bottom: 1px solid lightgray;
	    line-height: 2.8125rem;
			&.fl {
				float: none;
			}
			a {
				line-height: 2.8125rem !important;
        color: gray !important;
			}
		}
     .active {
      color: blue !important;
    }
	}
	.header {
		position: relative;
    background: #fff;
    .wrap-mulu {
      position: relative;
      background: #fff;
      z-index: 10;
    }
    .slide-down-enter-active {
      height: 20.125rem;
      transition: all 2s;
    }
    .slide-down-leave-active {
      transition: all 2s;
      height: 0;
      margin-top: -20.125rem;
    }
    .slide-down-enter, .slide-down-leave-to {
      opacity: 0;
      height: 0;
    }
	}
	nav {
		text-align: center;
	}
	img.fl {
		float: none;
	}
	.mulu-icon {
		display: block !important;
		position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .icon-menu2 {
    font-size: 2.5rem;
    color: rgb(224, 56, 56);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue